/**
 * 定义路径s
 */
const PATH = 'site_'
/*
包含n个mutation的type名称常量
 */
export const SITE_INIT = PATH + 'init'
export const SITE_CHANGE = PATH + 'change'
export const SITE_CHANGE_CONFIG_SITESEO = PATH + 'change_config_siteseo'
export const SITE_CONFIG_CHANGE = PATH + 'config_change'



// WEBPACK FOOTER //
// ./src/store/mutations/site/type.js